<template>
  <nav class="flex flex-column mobile:flex-row bg-light pd-medium radius-small">
    <RouterLink
      :to="basePath"
      class="flex flex-v-center pd-small mn-b-thin radius-small hover:bg-white"
      :class="{ 'bg-white': !route.path.endsWith('/account') }"
    >
      <IconProfile class="mn-r-thin i-medium"/>
      <span>Profile</span>
    </RouterLink>

    <RouterLink
      :to="basePath + '/account'"
      class="flex flex-v-center pd-small radius-small hover:bg-white"
      :class="{ 'bg-white': route.path.endsWith('/account') }"
    >
      <IconLock class="mn-r-thin i-medium"/>
      <span>Account</span>
    </RouterLink>
  </nav>
</template>

<script setup>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import * as auth from '@martyrs/src/modules/auth/views/store/auth.js'
  import IconProfile from '@martyrs/src/modules/icons/entities/IconProfile.vue';
  import IconLock from '@martyrs/src/modules/icons/entities/IconLock.vue';
  const route = useRoute()
  const userId = computed(() => route.params._id || auth.state.user._id)
  const basePath = computed(() => route.path.replace(/\/account$/, ''))
</script>